import * as ActionTypes from "./actionTypes";
import WebRtcHelper from "../misc/webrtchelper";
import UserSession from "../misc/usersession";
import UserService from "../services/userService";
import { loadSettings } from "./settingActions";
import { localIpAquired, requireMedia } from "./userActions";
import { register } from "./sipActions";

const configSystemLoaded = (systemConfig, config) => ({
  type: ActionTypes.CONFIG_SYSTEM_LOADED,
  payload: {
    systemConfig: systemConfig,
    config: config,
  },
});

const configInitCompleted = () => ({
  type: ActionTypes.CONFIG_INIT_COMPLETED,
  payload: {},
});

export const loginSuccess = user => ({
  type: ActionTypes.USER_LOGIN_SUCCESS,
  payload: {
    user: user,
  },
});

const loginFailed = (error, errorCode = -1) => {
  let type;

  switch (errorCode) {
    case 1006:
      type = ActionTypes.USER_LOGIN_FAILED_TOKEN_INVALID;
      break;
    case 1007:
      type = ActionTypes.USER_LOGIN_FAILED_TOKEN_EXPIRED;
      break;
    default:
      type = ActionTypes.USER_LOGIN_FAILED;
      break;
  }

  return {
    type,
    payload: {
      loginerror: error,
    },
  };
};

const webRtcDetected = isUsingPlugin => ({
  type: ActionTypes.WEBRTC_DETECTED,
  payload: {
    temasys: isUsingPlugin,
    webrtc: !isUsingPlugin,
  },
});

const noWebRtcDetected = () => ({
  type: ActionTypes.WEBRTC_DETECTED,
  payload: {
    temasys: false,
    webrtc: false,
  },
});

const configDebugEnable = () => ({
  type: ActionTypes.CONFIG_DEBUG_ENABLE,
  payload: {},
});

const detectUnsupportedBrowser = browser => {
  const browserVersionParts = browser.version.split(".");

  // Edge before it was rebuild on top of Chromium
  if (browser.name === "edge" && browserVersionParts[0] <= 44) {
    return true;
  }

  return false;
};

export function bootApplication() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.UNSUPPORTED_BROWSER,
      payload: detectUnsupportedBrowser(getState().config.browser),
    });

    WebRtcHelper.detect()
      .then(isUsingPlugin => {
        dispatch(webRtcDetected(isUsingPlugin));
      })
      .catch(() => {
        dispatch(noWebRtcDetected());
      })
      .finally(() => {
        if (UserSession.isEstablished()) {
          const user = UserSession.getUser();
          const systemConfig = UserSession.getSystemConfig();
          const localIpAddress = UserSession.getLocalIpAddress();
          dispatch(loginSuccess(user));
          dispatch(configSystemLoaded(systemConfig, getState().config));
          dispatch(loadSettings());
          dispatch(localIpAquired(localIpAddress));
          dispatch(
            requireMedia(
              getState().config.mode.audio,
              getState().config.mode.video,
              systemConfig,
              user,
              dispatch
            )
          );
        } else {
          if (getState().config.mode.anonymous_autologin) {
            dispatch(
              login(
                getState().config.anonymous.user,
                getState().config.anonymous.password
              )
            );
          }
        }
        dispatch(configInitCompleted());
      });
  };
}

export function login(username, password, token) {
  return (dispatch, getState) => {
    const success = ({ user, systemConfig, localIpAddress }) => {
      user.anonymous =
        getState().config.anonymous &&
        username === getState().config.anonymous.user;
      systemConfig.SYS_ALL_WEBRTC_SERVER_URI = systemConfig.SYS_WEBRTC_SERVER_URI.split(
        ","
      );
/*
      systemConfig.SYS_WEBRTC_SERVER_URI = getState().config.mode.video
        ? selectFreeswitch(
            getState().config.browserGroup,
            systemConfig.SYS_WEBRTC_SERVER_URI.split(",")
          )
        : loadBalance(systemConfig.SYS_WEBRTC_SERVER_URI.split(","));
*/
      UserSession.setUser(user);
      UserSession.setSystemConfig(systemConfig);
      UserSession.setLocalIpAddress(localIpAddress);
      dispatch(configSystemLoaded(systemConfig, getState().config));
      dispatch(loginSuccess(user));
      dispatch(loadSettings());
      dispatch(localIpAquired(localIpAddress));
      dispatch(
        requireMedia(
          getState().config.mode.audio,
          getState().config.mode.video,
          systemConfig,
          user,
          dispatch
        )
      );
      dispatch(configInitCompleted());
    };

    const failure = ({ errorCode, xhr, ajaxOptions, thrownError }) => {
      UserSession.removeUser();
      dispatch(
        loginFailed(errorMessage(errorCode, getState().config.text), errorCode)
      );
    };

    UserService.login(
      username,
      password,
      token,
      getState().config.server,
      dispatch
    )
      .then(success)
      .catch(failure);
  };
}

export function enableDebug() {
  return (dispatch, getstate) => {
    dispatch(configDebugEnable());
  };
}

/*
const loadBalance = servers => {
  //sipjs loadbalancing doesnt work with freeswitch, because uri
  //depends on which wsserver that is used. Just another example of
  //Freeswitch problems ...
  let index = Math.floor(Math.random() * servers.length);
  return servers[index];
};

const selectFreeswitch = (browserGroup, servers) => {
  browserGroup =
    servers[browserGroup].toLowerCase().indexOf("h264") !== -1 ? 1 : 0;
  return servers[browserGroup];
};
*/

export function switchFreeswitch() {
  return (dispatch, getstate) => {
    const systemConfig = UserSession.getSystemConfig();
    systemConfig.SYS_WEBRTC_SERVER_URI =
      systemConfig.SYS_ALL_WEBRTC_SERVER_URI.indexOf(
        systemConfig.SYS_WEBRTC_SERVER_URI
      ) === 0
        ? systemConfig.SYS_ALL_WEBRTC_SERVER_URI[1]
        : systemConfig.SYS_ALL_WEBRTC_SERVER_URI[0];
    UserSession.setSystemConfig(systemConfig);
    dispatch(configSystemLoaded(systemConfig, getstate().config));
    dispatch(register());
  };
}

const errorMessage = (errorCode, text) => {
  switch (errorCode) {
    case -7:
      return text("error.accountexpired");
    case -1:
    case 1001:
      return text("error.usernameorpassword");
    case -2:
      return text("error.noservercontact");
    case 1006:
      return text("error.tokeninvalid");
    case 1007:
      return text("error.tokenexpired");
    default:
      return text("error.unknown") + " " + errorCode;
  }
};

export const bindLocalStream = stream => ({
  type: ActionTypes.BIND_LOCAL_STREAM,
  payload: {
    stream: stream,
  },
});

export function unBindLocalStream() {
  return (dispatch, getstate) => {
    var localStream = getstate().config.localStream;
    if (localStream) {
      if (localStream.stop) {
        localStream.stop();
      } else {
        localStream.getTracks().forEach(function(track) {
          if (track && track.stop) {
            track.stop();
          }
        });
      }
      localStream = null;
    }
    dispatch({
      type: ActionTypes.UNBIND_LOCAL_STREAM,
    });
  };
}






// WEBPACK FOOTER //
// ./src/actions/configActions.js